import { AddressCard, AddressName, AddressText, Tags, Tag } from './styles'

// Google Places types that are noise on every result (every business is a
// "point_of_interest"/"establishment") — hide them, keep the useful ones
// (e.g. "restaurant", "bar", "cafe").
const HIDDEN_TYPES = new Set([
  'point_of_interest',
  'establishment',
  'premise',
  'geocode',
  'political'
])

const humanizeType = (type) => type.replace(/_/g, ' ')

// `meta` is stored via Sequelize's JSON column, which normally deserializes
// on read — but tolerate a raw string or missing value too, since some
// addresses predate this column (or were created outside the Google search
// flow) and shouldn't blow up the details page.
const parseMeta = (meta) => {
  if (!meta) return {}
  if (typeof meta === 'object') return meta
  try {
    const parsed = JSON.parse(meta)
    return typeof parsed === 'object' && parsed ? parsed : {}
  } catch {
    return {}
  }
}

const fallbackAddressText = (address) => {
  return (
    [address.street_address, address.city, address.country_area, address.postal_code]
      .filter(Boolean)
      .join(', ') || address.text
  )
}

export const AddressDetails = ({ address }) => {
  if (!address) return null

  const meta = parseMeta(address.meta)
  const name = meta.name || address.name
  const formatted = meta.formatted_address || fallbackAddressText(address)
  const types = (meta.types || []).filter((type) => !HIDDEN_TYPES.has(type))

  return (
    <AddressCard>
      {name && <AddressName>{name}</AddressName>}
      {formatted && <AddressText>{formatted}</AddressText>}
      {types.length > 0 && (
        <Tags>
          {types.map((type) => (
            <Tag key={type}>{humanizeType(type)}</Tag>
          ))}
        </Tags>
      )}
    </AddressCard>
  )
}

export const AddressList = ({ addresses }) => {
  if (!addresses?.length) return null

  return (
    <>
      {addresses.map((address) => (
        <AddressDetails key={address.id} address={address} />
      ))}
    </>
  )
}
